import { createContext, useContext } from 'react';
import type { Admin, AdminSessionReply } from '@london-life/contracts';

// the signed-in admin, their two-step status and permission check, available to every page without passing props down
export type AdminContextValue = {
  admin: Admin;
  twoStep: AdminSessionReply['twoStep'];
  can: (permission: string) => boolean;
};
export const AdminContext = createContext<AdminContextValue | null>(null);
export function useAdmin() {
  const value = useContext(AdminContext);
  if (!value) throw new Error('useAdmin is used outside the signed-in admin area');
  return value;
}
